import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Public API (marketing site)
export const api = axios.create({ baseURL: API });

export const fetchRoutes = (params = {}) => api.get("/routes", { params }).then(r => r.data);
export const fetchRoute = (slug) => api.get(`/routes/${slug}`).then(r => r.data);
export const fetchCities = () => api.get("/cities").then(r => r.data);
export const fetchCity = (slug) => api.get(`/cities/${slug}`).then(r => r.data);
export const fetchEvents = () => api.get("/events").then(r => r.data);
export const fetchEvent = (slug) => api.get(`/events/${slug}`).then(r => r.data);
export const fetchBlog = () => api.get("/blog").then(r => r.data);
export const fetchPost = (slug) => api.get(`/blog/${slug}`).then(r => r.data);
export const subscribe = (payload) => api.post("/community/subscribe", payload).then(r => r.data);
export const fetchCommunityCount = () => api.get("/community/count").then(r => r.data);
export const suggestRoute = (payload) => api.post("/community/suggest-route", payload).then(r => r.data);
export const addRouteReview = (slug, payload) => api.post(`/routes/${slug}/reviews`, payload).then(r => r.data);

/** Build a keyless, road-following Google Maps directions embed from waypoints. */
export function buildDirectionsEmbed(waypoints = []) {
  const pts = waypoints.filter((w) => typeof w.lat === "number" && typeof w.lng === "number");
  if (pts.length < 2) return null;
  const saddr = `${pts[0].lat},${pts[0].lng}`;
  const rest = pts.slice(1).map((p) => `${p.lat},${p.lng}`).join("+to:");
  return `https://maps.google.com/maps?saddr=${saddr}&daddr=${rest}&output=embed`;
}

// Admin API — attaches Bearer token from localStorage
export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("rotta_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("rotta_admin_token");
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export async function uploadImageSigned(file, folder = "rotta/routes") {
  const sig = (await adminApi.get(`/admin/upload/signature`, { params: { folder } })).data;
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);
  const res = await fetch(`https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`, {
    method: "POST",
    body: form,
  });
  if (!res.ok) {
    let msg = `Cloudinary ${res.status}`;
    try {
      const err = await res.json();
      if (err?.error?.message) msg += `: ${err.error.message}`;
    } catch { /* ignore parse */ }
    const e = new Error(msg);
    e.cloudinaryStatus = res.status;
    throw e;
  }
  const data = await res.json();
  return { url: data.secure_url, public_id: data.public_id };
}

export const ASSETS = {
  logoFull: "https://customer-assets.emergentagent.com/job_bddb7c88-402a-4534-ae71-8a50cbb2f628/artifacts/3usioky7_PNG.png",
  logoMark: "https://customer-assets.emergentagent.com/job_bddb7c88-402a-4534-ae71-8a50cbb2f628/artifacts/4gvm3c07_PNG%20-%20SEM%20FRASE.png",
  heroFallback: "https://customer-assets.emergentagent.com/job_bddb7c88-402a-4534-ae71-8a50cbb2f628/artifacts/nvm2rmw7_rota.jpg",
  capitaoMap: null,
};
